import { storage } from '../libs/firebase';
import {
  ref,
  uploadBytes,
  getDownloadURL,
  getMetadata,
} from 'firebase/storage';

export const uploadFile = async (file, name) => {
  try {
    const storageRef = ref(storage, `user_uploads/${name}`);

    await uploadBytes(storageRef, file);
    const [result, downloadLink] = await Promise.all([
      await getMetadata(storageRef),
      await getDownloadURL(storageRef),
    ]);

    return { uploadResult: [result], downloadLink };
  } catch (e) {
    throw e;
  }
};

export const makeid = async (length) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getFileDownloadUrl = async (path) => {
  const ref = await storage.refFromURL(
    `gs://mnc-cloud-ae72a.appspot.com/${path}`
  );
  const url = await ref.getDownloadURL();
  return url;
};
